import { render, staticRenderFns } from "./CreateDamage.vue?vue&type=template&id=778d6ef6&"
import script from "./CreateDamage.vue?vue&type=script&lang=js&"
export * from "./CreateDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports